import { Plugin, PluginKey } from "prosemirror-state";
const autospaceAfterMentionPlugin = new PluginKey("autospaceAfterMentionPlugin");
/**
 * Characters that should remove the space automatically added by a mention when typed immediatelly
 * after creating a mention.
 */
export const spaceAutoremovalChars = [".", ",", ":", ";", "!", "?", ")", "]"];
/**
 * Create a plugin that, when enabled, checks the next character pressed and whether it was inserted immediately after
 * a mention was inserted. If the typed character is a punctuation mark, then it removes the space created by the mention
 * that was just inserted and places the punctuation right after the mention.
 */
export const spaceAutoremovalPlugin = () => {
    return new Plugin({
        key: autospaceAfterMentionPlugin,
        state: {
            init: () => ({ check: false }),
            apply: (tr, value) => {
                if (!tr.getMeta(autospaceAfterMentionPlugin)) {
                    return value;
                }
                return tr.getMeta(autospaceAfterMentionPlugin);
            },
        },
        appendTransaction: (trs, _, state) => {
            const pluginState = autospaceAfterMentionPlugin.getState(state);
            if (!(pluginState === null || pluginState === void 0 ? void 0 : pluginState.check) || !(pluginState === null || pluginState === void 0 ? void 0 : pluginState.pos)) {
                // don't check if plugin wasn't activated
                return;
            }
            const { pos } = pluginState;
            if (pos === state.selection.from) {
                // don't check just yet if plugin was just activated but state hasn't changed ever since
                // (wait until a change happens)
                return;
            }
            const { tr } = state;
            tr.setMeta(autospaceAfterMentionPlugin, { check: false });
            if (state.doc.nodeSize - 1 > pos + 1) {
                const insertedCharacter = state.doc.textBetween(pos, pos + 1);
                if (spaceAutoremovalChars.includes(insertedCharacter)) {
                    tr.deleteRange(pos - 1, pos);
                }
            }
            return tr;
        },
    });
};
/**
 * Enables the `autospaceAfterMention` plugin to check next typed character.
 * This should be used every time a mention is created.
 */
export function checkSpaceAutoremoval(tr) {
    return tr.setMeta(autospaceAfterMentionPlugin, {
        check: true,
        pos: tr.selection.from,
    });
}
